<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsInsuranceProviderSelectionTitle')" [size]="'large'" (closeModal)="cancel.emit()">
    <div modal-content>
      <div class="flex flex-col md:flex-row gap-4 justify-center">
        @if (isVendorAvailable('geico')) {
          <button
            id="insurance-provider-geico-card"
            type="button"
            class="flex-1 p-4 border-2 rounded-xl text-left transition-all cursor-pointer hover:border-ld-primary hover:shadow-md focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
            [class.border-ld-primary]="selectedProvider() === 'geico'"
            [class.border-ld-neutral-200]="selectedProvider() !== 'geico'"
            [class.insurance-provider-card--selected]="selectedProvider() === 'geico'"
            (click)="onProviderSelect('geico')"
          >
            <div class="flex flex-col items-center text-center">
              <div class="w-16 h-16 mb-3 flex items-center justify-center">
                <img src="assets/images/vendor-geico.png" alt="GEICO logo" class="w-14 h-14 object-contain" />
              </div>
              <h3 class="text-card-title text-ld-neutral mb-2">GEICO</h3>
              <p class="text-body text-ld-neutral-500">
                {{ t('modalsInsuranceProviderSelectionGeicoDescription') }}
              </p>
            </div>
          </button>
        }

        @if (isVendorAvailable('mello')) {
          <button
            id="insurance-provider-mello-card"
            type="button"
            class="flex-1 p-4 border-2 rounded-xl text-left transition-all cursor-pointer hover:border-ld-primary hover:shadow-md focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
            [class.border-ld-primary]="selectedProvider() === 'mello'"
            [class.border-ld-neutral-200]="selectedProvider() !== 'mello'"
            [class.insurance-provider-card--selected]="selectedProvider() === 'mello'"
            (click)="onProviderSelect('mello')"
          >
            <div class="flex flex-col items-center text-center">
              <div class="w-16 h-16 mb-3 flex items-center justify-center">
                <img src="assets/images/vendor-mello.png" alt="melloInsurance logo" class="w-14 h-14 object-contain" />
              </div>
              <h3 class="text-card-title text-ld-neutral mb-2">melloInsurance</h3>
              <p class="text-body text-ld-neutral-500">
                {{ t('modalsInsuranceProviderSelectionMelloDescription') }}
              </p>
            </div>
          </button>
        }
      </div>

      <div class="mt-6 p-3 bg-ld-neutral-50 rounded-lg">
        <p class="text-caption text-ld-neutral-500 text-center">
          {{ t('modalsInsuranceProviderSelectionDisclaimer') }}
        </p>
      </div>
    </div>
    <div modal-footer>
      <button
        id="insurance-provider-selection-cancel-btn"
        type="button"
        class="btn-outline-ld-purple"
        (click)="onCancel()"
      >
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="insurance-provider-selection-continue-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="!selectedProvider()"
        (click)="onContinue()"
      >
        {{ t('commonButtonsContinue') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
